import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { analytics } from "@heycatch/sdk";
import "@/index.css";
import App from "@/App";

analytics.init({
  projectKey: "hck_pk_DAgkLQ_t5O3V0VcsZ5IeD0c9dq0m2kp9",
  install: {
    framework: "react",
    frameworkVersion: "19",
    agent: "other",
  },
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
